<div class="pc-content" style="background:white; padding: 10px">
    <div class="itemSelectionHolder">

        <div class="kendoHolderGrid">
            <p>Invoice Items</p>
            <kendo-grid
                #allCategoryItemsGrid
                (dataStateChange)="dataStateChangeInventoryDetails($event)"
                [data]="inventoryGridData"
                [filter]="_inventoryState.filter"
                [filterable]="true"
                [kendoGridSelectBy]="_removeCallBack"
                [navigable]="true"
                [reorderable]="true"
                [resizable]="true"
                [selectable]="{ checkboxOnly: false, mode: 'multiple' }"
                [selectedKeys]="_inventoryItemSelected"
                [skip]="_inventoryState.skip"
                [sortable]="true"
                class="kgridItem"
                id="grid-items"
                style="height: 65vh; width: 30vw">
                <kendo-grid-column [title]="'Id'" field="customerItem" filterable="true" width="60">
                </kendo-grid-column>
                <kendo-grid-column [title]="'Description'" field="description" filterable="true" width="240">
                </kendo-grid-column>

            </kendo-grid>
        </div>
        <div class="in-itemChangeGroup">
            <app-mcl-button (buttonPressed)="removeBtnClicked()" class="pc-center-buttons" text=" >>> "></app-mcl-button>
            <app-mcl-button (buttonPressed)="copyBtnClicked()" class="pc-center-buttons" text=" <<< "></app-mcl-button>
        </div>
        <div class="kendoHolderGrid">
            <p>All Items</p>

            <kendo-grid
                #itemsInGridGrid
                (dataStateChange)="dataStateChangeItemDetails($event)"
                [data]="gridData"
                [filter]="_stateItemsTable.filter"
                [filterable]="true"
                [kendoGridSelectBy]="_selectedCallback"
                [navigable]="true"
                [reorderable]="true"
                [resizable]="true"
                [selectable]="true"
                [selectedKeys]="_orderItemsSelected"
                [skip]="_stateItemsTable.skip"
                [sortable]="true"
                class="kgridItem"
                id="grid-item"
                style="height: 66vh; width: 100%">
                <kendo-grid-column [title]="'Id'" field="itemNo" filterable="true" width="60">
                </kendo-grid-column>
                <kendo-grid-column [title]="'Description'" field="description" filterable="true" width="240">
                </kendo-grid-column>
            </kendo-grid>

        </div>
    </div>
    <div class="add-item-cancel-btn">
        <app-mcl-button (buttonPressed)="cancelOnClick()" text="Cancel"></app-mcl-button>
    </div>
    <!--    <div  class="k-i-loading"></div>-->
    <!--    <mat-progress-bar-->

    <!--            style="position: absolute; top: 0; z-index: 5000;">-->
    <!--    </mat-progress-bar>-->
</div>

